/**
 * Toast notification helpers using @zerodevx/svelte-toast.
 *
 * Uses the `.success` and `.warning` CSS classes from `app.css`
 * for consistent styling across the application.
 */
import { toast } from '@zerodevx/svelte-toast';

/** Show a success toast (indigo background). */
export function toastSuccess(message: string): void {
	toast.push(message, { theme: { '--toastBackground': '#4f46e5', '--toastBarBackground': '#e5e7eb' } });
}

/** Show a warning toast (amber background). */
export function toastWarning(message: string): void {
	toast.push(message, { theme: { '--toastBackground': '#b45309', '--toastBarBackground': '#7f1d1d' } });
}

/** Show an error toast (red background). */
export function toastError(message: string): void {
	toast.push(message, { theme: { '--toastBackground': '#dc2626', '--toastBarBackground': '#7f1d1d' } });
}
